import {
  genElDate,
  genElText,
  genElZirvuImage,
} from "@components/utils/EditorDialogElementGenerator";
import SectionCard from "./section-card";
import SignatureRow from "./signature-row";

const signers = [
  { name: "diketahui_transport", label: "Diketahui", title: "PJ Transport" },
  { name: "diproses_oleh", label: "Diproses", title: "Petugas Pembelian" },
];

// III. Pembelian & Pengiriman (Transport)
const SectionPembelian = (props) => {
  const { data, setData, error, stage, saving, onSave, signProps, cardProps, imageFolder } =
    props;

  const disabled = stage !== "active";

  return (
    <SectionCard
      {...cardProps}
      code="III"
      title="Pembelian & Pengiriman"
      role="Transport"
      stage={stage}
      saving={saving}
      onSave={onSave}
      signatures={
        <SignatureRow
          signers={signers}
          data={data}
          canSign={stage === "active" && !!data.id}
          {...signProps}
        />
      }
    >
      {genElDate({
        field: "tanggal_beli",
        name: "Tanggal Beli",
        data,
        setData,
        error,
        disabled,
        primeFormat: "dd MM yy",
      })}
      {genElText({
        field: "bon_spbu",
        name: "No Bon SPBU",
        data,
        setData,
        error,
        disabled,
      })}
      {genElDate({
        field: "diserahkan_tanggal",
        name: "Diserahkan Tanggal",
        data,
        setData,
        error,
        disabled,
        showTime: true,
        primeFormat: "dd MM yy",
      })}
      {genElZirvuImage({
        field: "gambar_bon_spbu",
        name: "Foto Bon SPBU",
        data,
        setData,
        error,
        disabled,
        folderName: imageFolder,
      })}
    </SectionCard>
  );
};

export default SectionPembelian;
